export default "__VITE_ASSET__CWotVvdi__"